const clean = (value) => {
  if (value === null || value === undefined) return "";
  return String(value).trim();
};

export const getProductSize = (product) =>
  clean(product?.size || product?.product_details?.size || product?.purchase_item_details?.product?.size);

export const getUnitTitle = (unit) =>
  clean(unit?.title || unit?.name || unit?.unit_details?.title || unit?.purchase_item_details?.unit_details?.title);

export const formatProductWithSize = (product) => {
  const name = clean(product?.name) || "Product";
  const size = getProductSize(product);
  return [name, size].filter(Boolean).join(" - ");
};

export const formatProductWithSizeAndUnit = (product, unit) => {
  const unitTitle = getUnitTitle(unit);
  return [formatProductWithSize(product), unitTitle].filter(Boolean).join(" - ");
};
